import { render } from "./banners.vue?vue&type=template&id=29a5286d&scoped=true"
import script from "./banners.vue?vue&type=script&lang=js"
export * from "./banners.vue?vue&type=script&lang=js"

import "./banners.vue?vue&type=style&index=0&id=29a5286d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a5286d"]])

export default __exports__